// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the configuration from
// packages/oraclejet-preact/UNSAFE_Icon/themedIcons.config.json
import { IcoErrorS } from '../UNSAFE_Icons';
export default IcoErrorS;
